module.exports = __webpack_public_path__ + "img/icb-del-elite-m@3x.a4e30399.png";